function parsePrice(value) {
  if (value == null) return NaN;

  let str = String(value).trim();

  str = str.replace(/[^\d.,]/g, "");

  const hasDot = str.includes(".");
  const hasComma = str.includes(",");

  if (hasDot && hasComma) {
    const lastDot = str.lastIndexOf(".");
    const lastComma = str.lastIndexOf(",");

    if (lastDot > lastComma) {
      str = str.replace(/,/g, "");
    } else {
      str = str.replace(/\./g, "").replace(",", ".");
    }
  } else if (hasComma) {
    const parts = str.split(",");
    if (parts.length === 2 && parts[1].length <= 2) {
      str = str.replace(",", ".");
    } else {
      str = str.replace(/,/g, "");
    }
  } else if (hasDot) {
    const parts = str.split(".");
    if (parts.length > 2) {
      const decimal = parts.pop();
      str = parts.join("") + "." + decimal;
    }
  }

  return parseFloat(str);
}

document.addEventListener("click", function (e) {
  const modal = document.getElementById("instalmentsModal");
  if (!modal) return;

  const openButton = e.target.closest(".js-open-instalments-modal");
  const closeButton = e.target.closest("[data-modal-close]");
  const monthButton = e.target.closest(".js-month-switch");

  if (openButton) {
    if (!modal.open) {
      modal.showModal();
      document.body.classList.add("overflow-hidden");
    }
    return;
  }

  if (closeButton) {
    if (modal.open) {
      modal.close();
    }
    return;
  }

  if (monthButton) {
    const month = parseInt(monthButton.dataset.month, 10);
    const priceInput = modal.querySelector(".js-product-price-instalments");
    const selectedMonthText = modal.querySelector(".js-ratepay-selected-month");
    const monthlyRatePrice = modal.querySelector(".js-monthly-rate-price");
    const allSwitches = modal.querySelectorAll(".js-month-switch");

    if (!priceInput || !selectedMonthText || !monthlyRatePrice || !month) return;

    const total = parsePrice(priceInput.value);
    if (isNaN(total)) return;

    const monthlyPrice = (total / month).toFixed(2).replace(".", ",");

    selectedMonthText.textContent = month;
    monthlyRatePrice.textContent = monthlyPrice;

    allSwitches.forEach((btn) => btn.classList.remove("selected"));
    monthButton.classList.add("selected");
  }
});

document.addEventListener(
  "close",
  function (e) {
    if (e.target && e.target.id === "instalmentsModal") {
      document.body.classList.remove("overflow-hidden");
    }
  },
  true
);

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("instalmentsModal");
  if (!modal) return;

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.close();
    }
  });
});